import Button from '@app-studio-web/ui/components/Button'
import Layout from '@app-studio-web/ui/components/Layout'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'

const QUESTION_KEY = 'dream_recall_stats'

export default function DreamRecallStatsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [dreamMemoryChoice, setDreamMemoryChoice] = useState<string | null>(
    null,
  )

  const { isUpdate, postToReactNative } = useUpdateMode()

  useEffect(() => {
    // Get the user's dream memory choice from local storage
    const dreamMemoryAnswer = localStorage.getItem('onboarding_answers')
    if (dreamMemoryAnswer) {
      try {
        const parsed = JSON.parse(dreamMemoryAnswer)
        setDreamMemoryChoice(parsed.dream_memory.answer_key)
      } catch (e) {
        console.error('Error parsing dream memory answer:', e)
      }
    }
  }, [])

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const answer = {
      question_key: QUESTION_KEY,
      question: 'Dream recall statistics shown',
      answer_key: 'acknowledged',
      answer: 'acknowledged',
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      submit(event.currentTarget, { method: 'post' })
    }
  }

  return (
    <Layout>
      <div className="flex h-full flex-col">
        <div className="flex grow flex-col items-center justify-center text-center">
          {dreamMemoryChoice === 'every morning – it’s a whole movie' ? (
            // High dream recall - show impressive message
            <>
              <span className="mb-6 text-[100px]">🎊</span>
              <h1 className="custom-heading mb-6 text-3xl">
                {t('pages.onboarding.dreamRecallStats.highRecall.heading')}
              </h1>
              <div className="bg-custom-yellow max-w-[500px] rounded-[20px] px-6 py-5">
                <p className="text-left text-base">
                  {t('pages.onboarding.dreamRecallStats.highRecall.textStart')}{' '}
                  <strong>
                    {t(
                      'pages.onboarding.dreamRecallStats.highRecall.percentage',
                    )}
                  </strong>{' '}
                  {t('pages.onboarding.dreamRecallStats.highRecall.textEnd')}
                </p>
              </div>
            </>
          ) : (
            // Low dream recall - show encouraging message
            <>
              <span className="mb-6 text-[100px]">💡</span>
              <h1 className="custom-heading mb-6 text-3xl">
                {t('pages.onboarding.dreamRecallStats.lowRecall.heading')}
              </h1>
              <p className="mb-4 text-base">
                {t('pages.onboarding.dreamRecallStats.lowRecall.textStart')}
                <strong>
                  {t('pages.onboarding.dreamRecallStats.lowRecall.percentage')}
                </strong>{' '}
                {t('pages.onboarding.dreamRecallStats.lowRecall.textEnd')}
              </p>
              <div className="bg-custom-yellow max-w-[500px] rounded-[20px] px-6 py-5">
                <p className="text-left text-base">
                  {t(
                    'pages.onboarding.dreamRecallStats.lowRecall.encouragement',
                  )}
                </p>
              </div>
            </>
          )}
        </div>

        <Form className="mb-8 shrink-0" method="post" onSubmit={onSubmit}>
          <div className="flex justify-center">
            <Button
              title={t('pages.onboarding.dreamRecallStats.cool')}
              type="submit"
              dataTestId="button-continue"
            />
          </div>
        </Form>
      </div>
    </Layout>
  )
}
